module.exports = __webpack_public_path__ + "img/logo.8d849b8c.png";